<template>
    <div class="banner">
        <div class="align-self-center">
            <h1 style="white-space: pre-line;" class="banner__header sr-only" v-html="headerText">{{headerText}}</h1>
            <!-- <h5 style="white-space: pre-line;" class="banner__sub-header">{{subHeaderText}}</h5> -->
        </div>
    </div>
</template>

<script>
export default {
  props: ['headerText', 'subHeaderText', 'imgSrc'],
  data() {
    return {

    };
  },
  computed: {
    getBgWithGradient() {
      return `linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.7) ), url(${this.imgSrc})`;
    },
  },
};
</script>


<style lang="scss" scoped>


  /*------------------------------------*\
		#PRIMARY COLOURS
	\*------------------------------------*/


  /*------------------------------------*\
		#Mixins
	\*------------------------------------*/

  /*------------------------------------
    #MEDIA SCREENS < 768px (#MOBILE FIRST)
	\*------------------------------------*/

	/**
	* Banner
	*/
	.banner {
		background-repeat: no-repeat;
		background-size: cover;
		text-align: left;
		padding: 5rem 10% 5rem;
		min-height: 7rem;
		background-position: center;
		color: #000;

		// Elements
		&__header {
			text-transform: uppercase;
			font-weight: 700;
			font-size: 1.7rem;
			width: 50%;
		}
	}

  	/*------------------------------------*\
		#MEDIA SCREENS > 767px (TABLETS)
	\*------------------------------------*/
	@media (min-width:767px) {
		/**
		* Banner
		*/
		.banner {
			padding: 7rem 10% ;
			min-height: 10rem;

			// Elements
			&__header {
				font-size: 2rem;
				width: 50%;
			}
		}
	}

	/*------------------------------------*\
		#MEDIA SCREENS > 992px
		(LAPTOP, TABLET)
	\*------------------------------------*/
	@media (min-width:992px) {
		/**
		* Banner
		*/
		.banner {
			padding: 12rem 10% 10rem;
			min-height: 10rem;

			// Elements
			&__header {
				font-size: 2.5rem;
				width: 50%;
			}
		}

	}

	/*------------------------------------*\
		#MEDIA SCREENS > 1200px (DESKTOP)
	\*------------------------------------*/
	@media (min-width:1200px) {

	}

	/*------------------------------------*\
		#MEDIA SCREENS > 1320px (DESKTOP)
	\*------------------------------------*/
	@media (min-width:1320px) {

	}

	/*------------------------------------*\
		#MEDIA SCREENS > 1600px (DESKTOP)
	\*------------------------------------*/
	@media (min-width:1600px) {

    }
</style>
